import { getLocale } from "../runtime";

const sv_trackorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Spåra din order`
};

const trackorder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackorder(inputs)
	return "trackOrder";
};

export { trackorder as "trackOrder" };